/* ========================================================================== *\
	IMPORTS
\* ========================================================================== */
import bind from 'lodash/bind';

import { removeTime } from 'js-date-helper';

import { addListenerByQuery } from '../../01-helpers/event-manager';

import { getAvailability } from '../../03-api/calendar/get-availability';

import CalendarRenderer from './calendar-renderer';
import DatePicker from './date-picker.length-of-stay.js';



/* ========================================================================== *\
	PRIVATE VARIABLES
\* ========================================================================== */
const
	selector = {
		base: '.js-calendar'
	},
	attributeNames = {
		mindate: 'data-mindate',
		maxdate: 'data-maxdate'
	};

let
	instance = null,
	renderer = null;



/* ========================================================================== *\
	EVENT HANDLING
\* ========================================================================== */



/* ========================================================================== *\
	PRIVATE METHODS
\* ========================================================================== */
/**
 * Generates a random int between a provided min and max number.
 *
 * @param {Number} max The greatest possible number to return.
 * @param {Number} [min=0] Optional param to specify the smallest number to
 *        return. By default this is 0.
 *
 * @returns {Number} A random number between the min and max value (inclusive).
 */
function generateRandomInt(max, min = 0) {
	return Math.floor(Math.random() * (max - min + 1) + min);
}

/**
 *
 */
function createInstance() {
	const
		today = new Date(),
		minDate = new Date(document.querySelector(selector.base).getAttribute(attributeNames.mindate) ?? today),
		maxDate = new Date(document.querySelector(selector.base).getAttribute(attributeNames.maxdate) ?? new Date(new Date().setFullYear(new Date().getFullYear() + 1)));

	//maxDate.setFullYear(today.getFullYear() + 1);

	createRendererInstance();

	instance = new DatePicker(document.querySelector(selector.base), {
		currentDate: today,
		headerRenderer: (bind(renderer.renderHeader, renderer)),
		monthRenderer: bind(renderer.renderDays, renderer),
		minDate: removeTime(minDate),
		maxDate: maxDate,
		monthSpan: 1,
		selectionEnd: new Date(),
		selectionStart: new Date()
	});

	instance.numberOfDays = 1;
	instance.refreshCalendar();
}

/**
 *
 */
function createRendererInstance() {
	renderer = new CalendarRenderer();
	renderer.registerProvider(getAvailability);
}

/* ========================================================================== *\
	PUBLIC API
\* ========================================================================== */
/**
 *
 */
function init() {
	createInstance();
}



/* ========================================================================== *\
	EXPORTS
\* ========================================================================== */
export {
	init
};

if (document.querySelector('.js-calendar')) {
	init();
}
